// extracted by mini-css-extract-plugin
export default {"custom":"custom-module__custom--3xMyO"};